/* eslint-disable react/jsx-curly-brace-presence */
import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import Tag from 'screens/Integrations/components/IntegrationTag';

import Farm from './components/Farm';
import { SubmissionSummaryContext } from '../../context/SubmissionSummaryProvider';

const SummaryFarms = ({ farm, selectFarm }) => {
  const {
    state: { farms }
  } = useContext(SubmissionSummaryContext);
  const lengths = useMemo(
    () =>
      farm?.fields?.reduce(
        /* eslint-disable no-param-reassign */
        (result, field) => {
          result.cropzones += field.cropzones?.length;
          result.applications += field.cropzones?.reduce(
            (tasksCount, cropzone) => tasksCount + cropzone.tasks.length,
            0
          );

          return result;
        },
        { applications: 0, cropzones: 0 }
      ),
    [farm]
  );

  if (lengths?.cropzones === 0) return null;

  return (
    <div
      className="flex"
      style={{ justifyContent: 'space-between' }}
      data-testid="submission-summary-farms"
    >
      <Farm farm={farm} selectFarm={selectFarm} farms={farms} />
      <div className="flex">
        <div className="h-full">
          <div>
            <div className="flex -ml-1">
              <div className="m-1 whitespace-nowrap">
                <Tag color="#D60469">{lengths?.cropzones} Crop Zone(s)</Tag>
              </div>
              <div className="m-1 whitespace-nowrap">
                <Tag color="#2B9C92">
                  {lengths?.applications} Application(s)
                </Tag>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SummaryFarms.propTypes = {
  farm: PropTypes.shape().isRequired,
  selectFarm: PropTypes.func.isRequired
};

export default SummaryFarms;
